/**
 * Retirar un mensaje (no borrarlo): siempre se pregunta el motivo, de un toque. `pedirMotivoRetiro` abre el cuadro de RetiroHost (montado en el Layout)
 * y devuelve { motivo, motivo_texto } o null si la persona cancela. Lo usan el chat del SOA y los comentarios de las tareas y coberturas.
 */
export const MOTIVOS_RETIRO = [
  { id: "cuenta_equivocada", texto: "Me equivoqué de cuenta" },
  { id: "dato_incorrecto", texto: "Dato incorrecto" },
  { id: "iba_para_equipo", texto: "Iba para el equipo" },
  { id: "otro", texto: "Otro…" },
];

let hayHost = false;
export const registrarHostRetiro = (v) => { hayHost = !!v; };

/** modo: "retirar" (ahora) o "pedir" (pasado el plazo: lo resuelve el nivel más alto). `alCliente` avisa que el mensaje lo pudo ver el cliente. */
export function pedirMotivoRetiro({ modo = "retirar", alCliente = false, plazoH = 24 } = {}) {
  if (!hayHost || typeof window === "undefined") return Promise.resolve({ motivo: "otro", motivo_texto: "Retirado desde la app" });
  return new Promise((resolver) => { window.dispatchEvent(new CustomEvent("crew-pedir-retiro", { detail: { modo, alCliente, plazoH, resolver } })); });
}
